
cfnHttpInterceptorFactory.$inject = [
  '$q',
  '$rootScope',
  '$log',
  '$injector',
  'DemoAccountService',
  'i18nFilter'
];

export function cfnHttpInterceptorFactory(
  $q,
  $rootScope,
  $log,
  $injector,
  DemoAccountService,
  i18nFilter
) {
    var HTTP_INTERNAL_ERROR_CODE = 250;

    var configurations = {};
    var ANY_STATUS_CODE = new Object();

    function configureInterception(url, statusCode, config) {
      if (!configurations[url]) {
        configurations[url] = {};
      }
      var statusCode = statusCode || ANY_STATUS_CODE;
      if (!configurations[url][statusCode]) {
        configurations[url][statusCode] = [];
      }
      configurations[url][statusCode] = config;
    }

    function getConfiguration(url, status) {
      if (configurations[url]) {
        return (
          configurations[url][status] ||
          configurations[url][ANY_STATUS_CODE] ||
          {}
        );
      }
      return {};
    }

    return {
      /**
       * @name cfnHttpInterceptorConfiguration
       * @property {boolean} [false] doNotThrowError inhibits the interceptor to throw an error which will be catch by the OTS (Ticketing)
       */
      /**
       * @param {cfnHttpInterceptorConfiguration|undefined} options part of the configuration to simplify creation
       * @return {cfnHttpInterceptorConfiguration}
       */
      createConfiguration: function(options) {
        return _.defaults(options, {
          doNotThrowError: false
        });
      },

      /**
       * @param {string} url url to configure
       * @param {?number} statusCode status code to configure (leave empty to configure all)
       * @param {cfnHttpInterceptorConfiguration} config the configuration that will be used if url and statuscode (if given) matches.
       */
      configureInterception: configureInterception,

      /**
       * This method is called before each http request and could modify the config
       */
      request: function(config) {
        return config || $q.when(config);
      },

      /**
       * This method is called when the server returns a successful response (status code 2xx)
       */
      response: function(response) {
        var err = response.headers('FarmNet-Error');
        if (err) {
          // Remove waiting state in case there is no failure handler
          app.finishLoading();
          if (err === 'NoDemo') {
            DemoAccountService.displayDemoAccountAlert(response.data);
          } else if (
            err === 'MultipleErrors' &&
            response.data &&
            response.data.hasOwnProperty('errorMessageKeys')
          ) {
            response.data.errorMessageKeys.forEach(function(messageKey) {
              $rootScope.alertController.addTemporaryAlert(
                i18nFilter(messageKey),
                'error'
              );
            });
          } else if (err === 'RequiresProductLicense') {
            $rootScope.alertController.addTemporaryAlert(
              i18nFilter('fe.upgradeAccountPopup.admin.message'),
              'error'
            );
          } else if (
            (response.data && response.data.hasOwnProperty('showTicket')) ||
            response.data.hasOwnProperty('showAlert')
          ) {
            var $dialog = $dialog || $injector.get('$dialog');
            /** @type {{ showTicket: boolean, showAlert: boolean, messageKey: String, errorMessage: String }} */
            var data = response.data;
            var title = i18nFilter(data.messageKey);

            if (data.showTicket === true) {
              // don't throw error

              var $location = $location || $injector.get('$location');
              errorMessageService.reportException({
                message: title,
                cause: data.errorMessage,
                context: $location.path()
              });
            } else if (data.showAlert === true) {
              $rootScope.alertController.addPermanentAlert(message, 'error');
            }
          } else if (
            err == 'Generic' &&
            response.status == HTTP_INTERNAL_ERROR_CODE &&
            response.data.status
          ) {
            /**
             * 'Generic' errors are returned for WebApplicationException in presentation layer.
             * They should be handled in user code. Everything else shows a global alert.
             */

            //errors encapsulated over the 250 http code are here unwrapped
            response.status = response.data.status;
            response.statusText = response.data.statusText;
            response.data = response.data.data;
          } else {
            $rootScope.alertController.addPermanentAlert(
              i18nFilter(response.data),
              'error'
            );
          }
          // This request was not successful
          response = $q.reject(response);
        }

        return response;
      },

      /**
       * This method is called when the server sends a response in error state (status code 4xx, 5xx)
       */
      responseError: function(rejection) {
        //treat 3xx as angular does, but don'T write a ticket in the OTS for this!
        if (rejection.status && Math.floor(rejection.status / 100) == 3)
          return rejection;
        var callConfig = getConfiguration(
          rejection.config.url,
          rejection.status
        );
        $log.warn('response error', rejection);
        app.finishLoading();

        if (callConfig.doNotThrowError) return $q.reject(rejection);

        // Reverse proxy overwrites response body of errors, so we can't access
        // rejection.data

        // 401 Unauthorized -> Umleiten auf Login
        if (rejection.status === 401) {
          var redirectLocation = 'login.html';
          if (DemoAccountService.isDemoAccount()) {
            redirectLocation = 'https://www.365farmnet.com/';
          }
          window.location = redirectLocation;
          return $q.reject(rejection);
        }

        // Sonderbehandlung für magnolia/jasper/search
        if (
          rejection.status === 404 ||
          rejection.status === 500 ||
          rejection.status === 503
        ) {
          if (rejection.config && rejection.config.url) {
            var customMessages = ['magnolia', 'jasper', 'search'];
            for (var i = 0; i < customMessages.length; i++) {
              if (rejection.config.url.indexOf(customMessages[i]) > -1) {
                $rootScope.alertController.addTemporaryAlert(
                  i18nFilter('fe.connection.lost.message.' + customMessages[i]),
                  'error'
                );
                return $q.reject(rejection);
              }
            }
          }
        }

        // 402 Payment Required
        if (rejection.status == 402) {
          $rootScope.alertController.addTemporaryAlert(
            i18nFilter('fe.common.error.payment_required'),
            'error'
          );
          return $q.reject(rejection);
        }

        // 403 Forbidden / Rechte nicht vorhanden
        if (rejection.status == 403) {
          $rootScope.alertController.addTemporaryAlert(
            i18nFilter('fe.common.rightsPopup.basic.message'),
            'error'
          );
          return $q.reject(rejection);
        }

        // 404 Not found -> Verbindung verloren
        if (rejection.status == 404) {
          $rootScope.alertController.addTemporaryAlert(
            i18nFilter('fe.connection.lost.message'),
            'error'
          );
          return $q.reject(rejection);
        }

        if (rejection.status === 0) {
          // Ignore access-Control (loading Magnolia from localhost etc)
          return $q.reject(rejection);
        }

        // Für den Rest (>=500)
        // This hides the actual response object containing status and headers!
        throw new FarmnetHttpError(rejection);
      }
    }
}
